( function( $ ) {

	let initBlock  = function( section = false ) {
		const $section = section ? $( section ) : $( '.section-product-information' );

		if ( !$section.find( '.js-faq-item-toggler' ).length ) {
			return false;
		} else {
			$section.find( '.js-faq-item-toggler' ).on( 'click', function( e ) {
				e.preventDefault();
				let $btn = $( this );
				let $accordionItem = $btn.closest( '.faq-item' ); // Use closest to ensure the correct parent is selected
				let $accordionItemCollapse = $accordionItem.find( '.faq-item__body' );
    
				// Toggle functionality
				if ( !$accordionItem.hasClass( 'opened' ) ) {
					// Close all other items
					$section.find( '.faq-item' ).not( $accordionItem ).removeClass( 'opened' );
					$section.find( '.faq-item__body' ).not( $accordionItemCollapse ).collapse( 'hide' );
    
					// Open this item
					$accordionItem.addClass( 'opened' );
					$accordionItemCollapse.collapse( 'show' );
				} else {
					// Close this item
					$accordionItem.removeClass( 'opened' );
					$accordionItemCollapse.collapse( 'hide' );
				}
    
				// Handle enabling and disabling of toggler during animation to prevent rapid clicks
				$section.find( '.js-faq-item-toggler' ).attr( 'disabled', true );
				$accordionItemCollapse.on( 'shown.bs.collapse hidden.bs.collapse', function() {
					$section.find( '.js-faq-item-toggler' ).removeAttr( 'disabled' );
				} );
			} );
		}
	};

	window.app.loadBlock( initBlock, 'section-product-information', '.section-product-information' );
} )( jQuery );

jQuery( document ).ready( function() {
	jQuery( '.faq-closed .faq-item' ).removeClass( 'opened' );
	jQuery( '.faq-closed .faq-item__body' ).removeClass( 'show' );
} );